module.exports = __webpack_public_path__ + "img/sort-alpha.dcf5849f.svg";